import HeaderBackoffice from "component/HeaderBackoffice/HeaderBackoffice";
import { Container } from "@mui/material";
import SingleLogInForm from "component/SingleLogInForm/SingleLogInForm";

const Backoffice = (props) => {
  const link = "./backofficeL";
  return (
    <div>
      <Container fixed>
        <div>
          <HeaderBackoffice backoffice={""} />
        </div>
      </Container>
      <br />
      <Container maxWidth="md">
        <SingleLogInForm link={link} rol={"ROLE_ADMIN"} />
      </Container>
    </div>
  );
};
export default Backoffice;
